import { Controller } from "@hotwired/stimulus";

// Filters the denomination index list by worship/theology dimension sliders.
// Each slider ranges from -100 to 100 (mapped to -1.0..1.0 internally).
// Denominations must match ALL active sliders (AND logic) with progressive
// tolerance: tighter match required as the slider moves further from center.
//
// Coordinates with denomination-search via CSS classes: this controller
// toggles "hidden-by-slider", search toggles "hidden-by-search".
export default class extends Controller {
  static targets = [
    "slider",
    "denomination",
    "letterGroup",
    "counter",
    "letterNav",
  ];
  static DEADZONE = 5;

  connect() {
    this.totalCount = this.denominationTargets.length;
  }

  filter() {
    const active = this.activeSliders();

    this.denominationTargets.forEach((el) => {
      el.classList.toggle("hidden-by-slider", !this.passes(el, active));
    });

    this.updateLayout();
  }

  reset() {
    this.sliderTargets.forEach((s) => (s.value = 0));
    this.filter();
  }

  // --- private ---

  activeSliders() {
    return this.sliderTargets
      .filter(
        (s) => Math.abs(parseInt(s.value, 10)) > this.constructor.DEADZONE,
      )
      .map((s) => ({
        dimension: s.dataset.dimension,
        value: parseInt(s.value, 10) / 100,
      }));
  }

  passes(el, activeSliders) {
    if (activeSliders.length === 0) return true;

    const raw = el.dataset.scores;
    if (!raw) return false;

    const scores = JSON.parse(raw);
    return activeSliders.every(({ dimension, value }) => {
      const score = scores[dimension];
      if (score == null) return false;
      const tolerance = 1.0 - 0.7 * Math.abs(value);
      return Math.abs(score - value) <= tolerance;
    });
  }

  isHidden(el) {
    return Array.from(el.classList).some((c) => c.startsWith("hidden-by-"));
  }

  updateLayout() {
    let visibleCount = 0;
    this.denominationTargets.forEach((el) => {
      if (!this.isHidden(el)) visibleCount++;
    });

    this.letterGroupTargets.forEach((group) => {
      const items = group.querySelectorAll(
        '[data-denomination-slider-filter-target="denomination"]',
      );
      const anyVisible = Array.from(items).some((el) => !this.isHidden(el));
      group.style.display = anyVisible ? "" : "none";
    });

    if (this.hasLetterNavTarget) {
      this.letterNavTarget.style.display =
        visibleCount < this.totalCount ? "none" : "";
    }

    if (this.hasCounterTarget) {
      if (visibleCount < this.totalCount) {
        this.counterTarget.textContent = `Showing ${visibleCount} of ${this.totalCount} denominations`;
        this.counterTarget.style.display = "";
      } else {
        this.counterTarget.style.display = "none";
      }
    }
  }
}
